(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Mapaimagem', Mapaimagem);

    Mapaimagem.$inject = ['$resource'];

    function Mapaimagem ($resource) {
        var resourceUrl =  'api/mapaimagems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'querySemImagem': { 
                url: '/api/mapaimagemssemimagem',
                method: 'GET', 
                isArray: true},
            'queryImagem': { 
                url: '/api/mapaimagemsimagem/:mapaid',
                method: 'GET', 
                isArray: true},
            'queryImagemPequena': { 
                url: '/api/mapaimagemsimagempequena/:mapaid',
                method: 'GET', 
                isArray: true},
            'queryComparativoPragaSaude': { 
                url: '/api/mapaimagems/:safraid/:busca',
                method: 'GET', 
                isArray: true},
            'queryComparativoNutricional': { 
                url: '/api/mapanutricionalimagems/:safraid/:busca',
                method: 'GET', 
                isArray: true},
            'queryShapefile': { 
                url: '/api/mapaimagemsshapefile/:mapaid',
                method: 'GET', 
                isArray: true},
            'queryCSV': { 
                url: '/api/mapaimagemscsv/:mapaid',
                method: 'GET', 
                isArray: true},
            'queryWKT': { 
                url: '/api/mapaimagemswkt/:mapaid',
                method: 'GET', 
                isArray: true},
            'queryGaleria': {
                url: 'api/mapaimagems/galeria/:propid',  
                method: 'GET', 
                isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
